export const manifestLocales = {
  upload: {
    previewImageAlt: {
      en: 'image widget',
      he: 'תמונה'
    }
  }
};
